import {
    TAddServiceKey,
    TAddServiceValue,
    TEventKey,
    TEventValue,
} from 'components/contactForm/contactForm.types';
import { useTranslation } from 'react-i18next';

export const useGetEventOptions = (): {
    key: TEventKey;
    label: TEventValue;
}[] => {
    const { t } = useTranslation();

    return [
        { key: 'wedding', label: t('contactForm.eventType.wedding') },
        {
            key: 'corporateEvent',
            label: t('contactForm.eventType.corporateEvent'),
        },
        { key: 'presentation', label: t('contactForm.eventType.presentation') },
        {
            key: 'birthdayParty',
            label: t('contactForm.eventType.birthdayParty'),
        },
        { key: 'other', label: t('contactForm.eventType.other') },
    ];
};

export const useGetBudgetOptions = (): {
    key: string;
    label: string;
}[] => {
    const { t } = useTranslation();

    return [
        { key: '500', label: '500-1500€' },
        {
            key: '1500',
            label: '1500-3000€',
        },
        { key: '3000', label: '3000-6000€' },
        { key: 'other', label: t('contactForm.eventType.other') },
    ];
};

export const useGetAddServicesOptions = (): {
    key: TAddServiceKey;
    label: TAddServiceValue;
}[] => {
    const { t } = useTranslation();

    return [
        {
            key: 'costumesTailoring',
            label: t('contactForm.addService.costumesTailoring'),
        },
        {
            key: 'choreography',
            label: t('contactForm.addService.choreography'),
        },
        {
            key: 'showWithAVocalist',
            label: t('contactForm.addService.showWithAVocalist'),
        },
        {
            key: 'acrobatShow',
            label: t('contactForm.addService.acrobatShow'),
        },
        { key: 'photoZone', label: t('contactForm.addService.photoZone') },
    ];
};
